import React from "react";
import { StyleSheet, View } from "react-native";

import Text from "@components/AppText";
import t from "@constants/localization";
import { scale } from "@utils/scale";
import { useSelector } from "react-redux";
import { normalize } from "./metrics";

function CommissionStrip({ commission, height, fontSize }) {
  const { show_product_commission = true } = useSelector((s) => s.auth.user);
  return show_product_commission ? (
    <View style={[styles.container, { height: height ?? normalize(24) }]}>
      <Text style={{ fontSize: fontSize ?? 14 }} fontType="content3" center>
        {`${t("common/commission")} `}
        <Text bold style={styles.text}>
          ₹{commission}
        </Text>
      </Text>
    </View>
  ) : null;
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: "rgba(228, 0, 70, 0.05)",
    borderRadius: 4,
    justifyContent: "center",
    height: normalize(30),
    minWidth: scale(90),
    alignItems: "center",
    paddingHorizontal: normalize(8),
  },
});

export default CommissionStrip;
